import { isoZ, z } from 'my-zod'
import { productLineOptions, StrictLanguageEnum } from '../../internal'
import { additionalWaiverQuestion } from '../outfitter-waiver-content'

export const polarisWaiverContentTemplateModel = z.object({
  id: z.string().uuid(),
  versionId: z.number(),
  name: z.string().min(1),
  language: StrictLanguageEnum,
  compatibleProductLines: z.enum(productLineOptions).array(),
  template: z.string().min(1),
  outfitterName: z.string().nullable(),
  standardProtectionPrice: z.number().nullable().setLabel('Standard Protection Additional Charge'),
  premierProtectionPrice: z.number().nullable().setLabel('Premier Protection Additional Charge'),
  driverMinimumAge: z.number().nullable(),
  driverMinimumAgeCustomLanguage: z.string().nullable(),
  ageToCarryMinorPassenger: z.number().nullable(),
  ageToCarryMinorPassengerCustomLanguage: z.string().nullable(),
  minorPassengerAge: z.number().nullable(),
  minorPassengerAgeCustomLanguage: z.string().nullable(),
  travelRadius: z.string().nullable(),
  travelRadiusCustomLanguage: z.string().nullable(),
  governedByState: z.string().nullable(),
  arbitrationActState: z.string().nullable(),
  lossOfRentalsPaymentMaxDays: z.number().nullable(),
  damagePaymentWindow: z.string().nullable(),
  depositHoldWindow: z.string().nullable(),
  checkOutTime: z.string().nullable(),
  checkInTime: z.string().nullable(),
  rentalTimeCustomLanguage: z.string().nullable(),
  oneHourLateFee: z.string().nullable(),
  twoHourLateFee: z.string().nullable(),
  legalActionTime: z.string().nullable(),
  cancellationNotice: z.string().nullable(),
  vehicleTamperingFine: z.string().nullable(),
  overviewQ1: z.string().max(280).nullable(),
  overviewQ2: z.string().max(280).nullable(),
  overviewQ3: z.string().max(280).nullable(),
  overviewQ4: z.string().max(280).nullable(),
  overviewQ5: z.string().max(280).nullable(),
  overviewQ6: z.string().max(280).nullable(),
  safetyVideoUrl: z.string().nullable(),
  rideLanguageType: z.enum(['Generic', 'RideSpecific']).nullable(),
  requireMotorcycleLicense: z.boolean().nullable(),
  productImage: z.string().nullable(),
  checkoutSafetyQ1: z.string().nullable(),
  checkoutSafetyQ2: z.string().nullable(),
  checkoutSafetyQ3: z.string().nullable(),
  checkoutSafetyQ4: z.string().nullable(),
  checkoutSafetyQ5: z.string().nullable(),
  checkoutSafetyQ6: z.string().nullable(),
  additionalWaiverQuestions: additionalWaiverQuestion.array().nullable(),
  lastModifiedDate: isoZ.instant(),
  lastModifiedByProfileId: z.number(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type polarisWaiverContentTemplateModel = z.infer<typeof polarisWaiverContentTemplateModel>
